import React from 'react';

import ShimmerComponent from '../../../shimmerComponent/shimmerComponent';
import ShimmerEmptyImageTextComponent from './shimmerEmptyImageTextComponent';
import EmptyVoiceMsg from '../../../../../assets/svgComponents/EmptyVoiceMsg';

import './overviewVoiceMessagesShimmerComponent.css';

const OverviewVoiceMessagesShimmerComponent = ({showShimmer = true}) => {
  return (
    <>
      {showShimmer ? (
        <>
          {Array.from({length: 3}).map((val, idx) => (
            <div key={idx} className="et-v2-overview-voice-msg-shimmer-wrap">
              <ShimmerComponent />
            </div>
          ))}
        </>
      ) : (
        <div className="et-v2-overview-voice-msg-empty-shimmer-wrap">
          <ShimmerEmptyImageTextComponent
            ImageComponent={EmptyVoiceMsg}
            titleTxt="No voice messages"
            subTitleTxt="You currently have no unread voice messages"
          />
        </div>
      )}
    </>
  );
};

export default OverviewVoiceMessagesShimmerComponent;
